import { render, staticRenderFns } from "./WorkAlert.vue?vue&type=template&id=86889ea4"
import script from "./WorkAlert.vue?vue&type=script&lang=js"
export * from "./WorkAlert.vue?vue&type=script&lang=js"
import style0 from "./WorkAlert.vue?vue&type=style&index=0&id=86889ea4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports